import { MAIN_COLOR, SECONDARY_COLOR } from "../../constants/common/utils";
import { TXGUISection } from "../../interfaces/gui/fields.interfaces";

export const X_HEADER_GUI_FIELDS: TXGUISection = {
  Général: [
    {
      type: "toggle_option",
      name: "headerMode",
      label: "Mode",
      options: [
        { value: "static", label: "Statique" },
        { value: "sticky", label: "Sticky" },
        { value: "fixed", label: "Fixe" },
      ],
      defaultValue: "static",
    },
    {
      type: "sides",
      name: "position",
      label: "Position",
      units: ["px", "em", "%", "auto"],
    },
    {
      type: "boxShadow",
      name: "boxShadow",
      label: "Ombre",
      placeholder: "0px 0px 5px 5px #000000",
    },
    {
      type: "color",
      name: "bgColor",
      label: "Couleur d'arriere plan",
      defaultValue: MAIN_COLOR,
    },
    {
      type: "number",
      name: "blur",
      label: "Flou",
      defaultValue: 0,
    },
    {
      type: "toggle_option",
      name: "collapseAt",
      label: "BreakPoint",
      options: [
        { value: "sm", label: "Mobile" },
        { value: "md", label: "Tablette" },
      ],
      defaultValue: "md",
    },
    {
      type: "toggle_option",
      name: "menuPosition",
      label: "Position du Menu",
      options: [
        { value: "flex-start", label: "Gauche" },
        { value: "center", label: "Centre" },
        { value: "flex-end", label: "Droit" },
      ],
      defaultValue: "flex-start",
    },
    {
      type: "sizing",
      name: "height",
      label: "Hauteur",
    },
    {
      type: "toggle_option",
      name: "backgroundMode",
      label: "Mode de l'arriere plan",
      options: [
        { value: "CONTAINED", label: "Containeur" },
        { value: "FILL", label: "Remplir" },
      ],
      defaultValue: "FILL",
    },
    {
      type: "toggle_option",
      name: "containerMode",
      label: "type de Container",
      options: [
        { value: "NONE", label: "Aucun" },
        { value: "CENTER", label: "Centrer" },
        { value: "FILL", label: "Large" },
      ],
      defaultValue: "CENTER",
    },
  ],
  Logo: [
    {
      type: "image",
      name: "logo",
      label: "Logo du Site",
      defaultValue:
        "https://dev.xoraia.com/_next/image?url=%2Fimages%2FLOGO_XORAIA_WHITE.png&w=96&q=75",
    },
    {
      type: "sizing",
      name: "logoHeight",
      label: "Hauteur",
      defaultValue: "44px",
    },
    {
      type: "text",
      name: "LogoText",
      label: "Texte du Logo",
    },
    {
      type: "color",
      name: "logoTextColor",
      label: "Couleur du texte",
    },
    {
      type: "sizing",
      name: "logoTextFontSize",
      label: "Taille de la police",
      placeholder: "10",
      units: ["px", "em", "rem", "pt"],
    },
    // {
    //   type: "font",
    //   name: "logoTextFontFamily",
    //   label: "Police",
    //   defaultValue: "inherit",
    // },
    {
      type: "select_option",
      name: "logoTextFontWeight",
      label: "Epaisseur de la police",
      options: [
        { value: 100, label: "Mince" },
        { value: 200, label: "Tres Léger" },
        { value: 300, label: "Léger" },
        { value: 400, label: "Normal" },
        { value: 500, label: "Moyen" },
        { value: 600, label: "Semi-gras" },
        { value: 700, label: "Gras" },
        { value: 800, label: "Extra Gras" },
        { value: 900, label: "Lourd" },
      ],
      defaultValue: 400,
    },
  ],
  "Menu & Liens": [
    {
      type: "color",
      name: "contentColor",
      label: "Couleur du texte",
      defaultValue: "#FFFFFF90",
    },
    {
      type: "toggle_option",
      name: "contentTextTransform",
      label: "Format des Liens",
      options: [
        { value: "capitalize", label: "Capital" },
        { value: "uppercase", label: "Majuscule" },
        { value: "lowercase", label: "Minuscule" },
      ],
      defaultValue: "capitalize",
    },
    {
      type: "sizing",
      name: "contentLetterSpacing",
      label: "Espacement des lettres",
      placeholder: "0",
      units: ["px", "em"],
      defaultValue: "0px",
    },
    {
      type: "sizing",
      name: "contentFontSize",
      label: "Taille de la police",
      placeholder: "10",
      units: ["px", "em", "rem", "pt"],
      defaultValue: "16px",
    },
    {
      type: "select_option",
      name: "contentFontWeight",
      label: "Epaisseur de la police",
      options: [
        { value: 100, label: "Mince" },
        { value: 200, label: "Tres Léger" },
        { value: 300, label: "Léger" },
        { value: 400, label: "Normal" },
        { value: 500, label: "Moyen" },
        { value: 600, label: "Semi-gras" },
        { value: 700, label: "Gras" },
        { value: 800, label: "Extra Gras" },
        { value: 900, label: "Lourd" },
      ],
      defaultValue: 500,
    },
    {
      type: "color",
      name: "contentHoverColor",
      label: "Couleur du texte (Survole)",
      defaultValue: "#FFFFFF",
    },
  ],
  Icône: [
    {
      type: "color",
      name: "iconColor",
      label: "Couleur de l'Icone",
      defaultValue: "#FFFFFF",
    },
    {
      type: "color",
      name: "iconBgColor",
      label: "Couleur d'arriere plan",
    },
    {
      type: "border",
      name: "iconBorder",
      label: "Bordure",
      units: ["px", "em"],
    },
    {
      type: "radius",
      name: "iconRadius",
      label: "Arrondis",
      units: ["px", "em", "%"],
    },
    {
      type: "color",
      name: "iconHoverColor",
      label: "Couleur de l'Icone (Survole)",
      defaultValue: "#000000",
    },
    {
      type: "color",
      name: "iconHoverBgColor",
      label: "Couleur d'arriere plan (Survole)",
      defaultValue: "#FFFFFF",
    },
    {
      type: "border",
      name: "iconHoverBorder",
      label: "Bordure (Survole)",
      units: ["px", "em"],
    },
  ],
  Badges: [
    {
      type: "color",
      name: "badgeColor",
      label: "Couleur du Badge",
      defaultValue: SECONDARY_COLOR,
    },
    {
      type: "color",
      name: "badgeTextColor",
      label: "Couleur du Texte",
      defaultValue: "#FFFFFF",
    },
  ],
  // TODO ADD LATER
  // Avatar: [
  //   {
  //     type: "color",
  //     name: "avatarBgColor",
  //     label: "Couleur de l'Avatar",
  //     defaultValue: "#000000",
  //   },
  //   {
  //     type: "color",
  //     name: "avatarTextColor",
  //     label: "Couleur du Texte",
  //     defaultValue: "#FFFFFF",
  //   },
  // ],
};
